import { ReactNode } from 'react';
import { Panel, PanelArrow } from '@creditflowresearch/uilib/PanelGroup';
import IconExpand from '@creditflowresearch/uilib/Icon/IconExpand';
import IconCollapse from '@creditflowresearch/uilib/Icon/IconCollapse';

import styles from './filterSection.module.scss';

interface IFilterSectionProps {
  sectionId: string,
  children: ReactNode,
  dataTest?: string,
  header: ReactNode,
}

const FilterSection = ({
  sectionId,
  children,
  dataTest = 'filterSection',
  header,
}: IFilterSectionProps) => (
  <Panel
    header={ header }
    key={ sectionId }
    id={ sectionId }
    dataTest={ dataTest }
    arrow={ <PanelArrow arrowWrapperClassName={ styles.arrow } icon={ IconExpand } /> }
    arrowActive={ <PanelArrow arrowWrapperClassName={ styles.arrow } icon={ IconCollapse } /> }
    className={ styles.panel }
    headerClass={ styles.header }
    arrowWrapperClass={ styles.panelArrow }
    contentClass={ styles.panelContent }
  >
    { children }
  </Panel>
);

export default FilterSection;
